import { createVNode as _createVNode } from "vue";
import { defineComponent, useCssModule, computed } from "vue";
export default defineComponent({
  props: {
    title: String,
    data: [Array],
    isMl0: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    itemWidth: {
      type: String,
      default: "900px"
    },
    itemHeight: {
      type: String,
      default: "18px"
    },
    minTitleWidth: {
      type: String,
      default: "10em"
    }
  },
  setup(props, ctx) {
    const css = useCssModule("css");
    const myData = computed(() => {
      if (props.data) {
        props.data.forEach(item => {
          if (typeof item == "object" && item && item.show === undefined) {
            item.show = true;
          }
        });
        return props.data.filter(d => !!d && d.show);
      }
      return [];
    });
    return () => _createVNode("div", {
      "class": [css.detail]
    }, [props.title && _createVNode("h3", {
      "class": css.title
    }, [props.title]), _createVNode("div", {
      "class": [css.cont, {
        ml0: props.isMl0
      }]
    }, [myData.value.map(d => _createVNode("div", {
      "class": [css.cont_item, {
        w100: props.block
      }, {
        [css.base_line]: props.block
      }],
      "style": {
        width: props.itemWidth
        // height: props.itemHeight,
        // lineheight: props.itemHeight,
      }
    }, [_createVNode("div", {
      "class": css["no_wrap"],
      "style": {
        "min-width": props.minTitleWidth
      }
    }, [`${d.title}：`]), _createVNode("div", {
      "class": [{
        w70: props.block
      }, "ellipsis"]
    }, [typeof d.content == "function" ? d.content() : d.content])]))])]);
  }
});